import React from 'react';
import { Clock, FileText, CheckCircle } from 'lucide-react';
interface BOMVersionHistoryProps {
  selectedVersion: string;
}
export function BOMVersionHistory({
  selectedVersion
}: BOMVersionHistoryProps) {
  const versions = [{
    version: 'v2.1',
    status: 'active',
    date: '2024-01-15',
    changes: ['Increased Vitamin D3 from 800 IU to 1000 IU', 'Updated B-Complex blend formulation', 'Updated packaging specifications'],
    erpReference: 'ERP-2024-0115-001'
  }, {
    version: 'v2.0',
    status: 'archived',
    date: '2023-12-10',
    changes: ['Added Zinc Gluconate 15mg', 'Removed Iron', 'Updated capsule specifications'],
    erpReference: 'ERP-2023-1210-001'
  }, {
    version: 'v1.3',
    status: 'archived',
    date: '2023-11-05',
    author: 'Emma Wilson',
    changes: ['Cost optimization: switched Vitamin C supplier', 'Updated excipient ratios', 'Minor potency adjustments'],
    changeType: 'minor',
    notes: 'Cost reduction initiative'
  }];
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'active':
        return <CheckCircle className="w-4 h-4 text-green-600" data-id="element-126" />;
      case 'archived':
        return <Clock className="w-4 h-4 text-gray-400" data-id="element-127" />;
      default:
        return <FileText className="w-4 h-4 text-gray-400" data-id="element-128" />;
    }
  };
  return <div className="bg-white rounded-lg border p-6" data-id="element-129">
      <div className="flex items-center space-x-2 mb-4" data-id="element-130">
        <FileText className="w-5 h-5 text-gray-600" data-id="element-131" />
        <div data-id="element-132">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-133">
            BOM Version History
          </h3>
          <p className="text-sm text-gray-600" data-id="element-134">Imported from ERP System</p>
        </div>
      </div>
      <div className="space-y-4" data-id="element-135">
        {versions.map(version => <div key={version.version} className={`relative border rounded-lg p-4 ${version.version === selectedVersion ? 'border-purple-200 bg-purple-50' : 'border-gray-200 hover:border-gray-300'} transition-colors cursor-pointer`} data-id="element-136">
            <div className="flex items-start space-x-3" data-id="element-137">
              {getStatusIcon(version.status)}
              <div className="flex-1 min-w-0" data-id="element-138">
                <div className="flex items-center justify-between mb-2" data-id="element-139">
                  <div className="flex items-center space-x-2" data-id="element-140">
                    <h4 className="font-medium text-gray-900" data-id="element-141">
                      {version.version}
                    </h4>
                    {version.status === 'active' && <span className="inline-flex px-2 py-1 rounded text-xs font-medium bg-green-100 text-green-800" data-id="element-142">
                        Active
                      </span>}
                  </div>
                </div>
                <div className="text-sm text-gray-600 mb-3" data-id="element-143">
                  <span data-id="element-144">
                    Imported {new Date(version.date).toLocaleDateString()}
                  </span>
                  <span className="mx-2" data-id="element-145">•</span>
                  <span data-id="element-146">Ref: {version.erpReference}</span>
                </div>
                <div className="space-y-1" data-id="element-147">
                  {version.changes.map((change, changeIndex) => <div key={changeIndex} className="flex items-start space-x-2 text-sm" data-id="element-148">
                      <span className="text-gray-400 mt-1" data-id="element-149">•</span>
                      <span className="text-gray-600" data-id="element-150">{change}</span>
                    </div>)}
                </div>
              </div>
            </div>
          </div>)}
      </div>
      <div className="mt-6 pt-4 border-t border-gray-200" data-id="element-151">
        <button className="w-full text-sm text-purple-600 hover:text-purple-700 font-medium" data-id="element-152">
          View Complete History
        </button>
      </div>
    </div>;
}